export { track } from "@/lib/analytics-client";
export type { TrackParams } from "@/lib/analytics-client";

import { track } from "@/lib/analytics-client";
import { SOURCES, type SnowpadEvent } from "@/lib/analytics-events";

export function trackSignUp(method: string = "email") {
  track("auth_signup_succeeded", SOURCES.signUpForm, { method });
}

export function trackLogin(method: string = "email") {
  track("auth_login_succeeded", SOURCES.signInForm, { method });
}

export function trackPurchase(params: {
  transaction_id: string;
  value: number;
  currency: string;
  plan: string;
}) {
  track("checkout_payment_succeeded", SOURCES.billingClient, params);
}

export function trackProxyRotate() {
  track("proxy_rotate_clicked", SOURCES.proxiesPage);
}

export function trackApiKeyCreate() {
  track("api_key_created", SOURCES.apiKeyList);
}

export function trackEvent(eventName: string, params?: Record<string, string | number | boolean>) {
  track(eventName as SnowpadEvent, SOURCES.apiClient, params);
}
